import { axiosInstance as axios } from "./axiosInstance";

const URL = `/api/v2/dashboard`

export const getUsers = () => {
    return axios.get(`${URL}/users`)
}

export const getUser = (id) => {
    return axios.get(`${URL}/users/${id}`)
}